import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import SAlert from "components/Alert"
import { getProviderOuts } from "store/provider-out/provider-out-action"
import useSearch from "hooks/useSearch"
import ProviderOutDetailModal from "components/ProviderOut/details"
import ProviderDistributionActionRequestListComponent from "components/ProviderActionRequests/Distributions/list"
import { sendProviderDistributionActionRequests } from "store/provider-action-requests/provider-action-request-action"
import {
  getIps,
  getItemCategories,
  getProjects,
  getProvinces,
} from "store/admin/admin-dashboard-action"
import ProvinceDistributionActionRequestComponent from "components/ProvinceActionRequests/Distributions/lists"
import {
  getProvinceDistributionActionRequests,
  sendProvinceDistributionActionRequests,
} from "store/province-action-requests/province-action-request-action"
import {
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderProvinces,
} from "store/provider-dashboard/provider-dashboard-action"
import ProvinceOutDetailModal from "components/ProvinceOut/Details"

const ProvinceDistributionActionRequestList = () => {
  document.title = "Request For Deletion"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(
    state => state.provinceActionRequest
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProvinceDistributionActionRequests(ids, "Delete"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }
  const onCancelDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProvinceDistributionActionRequests(ids, "Cancel"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  const onPageClick = link => {
    dispatch(
      getProvinceDistributionActionRequests(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useSearch(
    getProvinceDistributionActionRequests(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  useEffect(() => {
    dispatch(
      getProvinceDistributionActionRequests(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderProjects())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProvinceDistributionActionRequests(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      <ProvinceOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"Distribution Request For Action"}
      />
      <ProvinceDistributionActionRequestComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onCancelDeleteClicked={onCancelDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
      />
    </React.Fragment>
  )
}

export default ProvinceDistributionActionRequestList
